import { render, staticRenderFns } from "./ScrollVirtualField.vue?vue&type=template&id=561ae8fa&"
import script from "./ScrollVirtualField.vue?vue&type=script&lang=js&"
export * from "./ScrollVirtualField.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports